module.exports = __webpack_public_path__ + "img/courseList.1b799b1d.svg";